import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const StyreneSigns = () => {

  const servicesFaqData = [
    {
        question: "What are styrene signs, and where are they used?",
        answer: "Styrene signs are lightweight, flexible signage solutions made from durable plastic material. They are used in retail displays, trade shows, exhibitions, and point-of-sale marketing for their versatility and professional appearance."
    },
    {
        question: "What are the benefits of custom styrene sign printing?",
        answer: "Custom Styrene Sign Printing offers vibrant visuals, sharp details, and lightweight material for easy handling. Styrene signs are cost-effective, durable, and suitable for short-term promotions and long-term branding."
    },
    {
        question: "Can Printingy handle bulk orders for styrene sign printing?",
        answer: "Yes, Printingy specialises in bulk styrene sign printing. We ensure consistent quality, cost-effective solutions, and timely delivery for large-scale orders, making us a reliable partner for all your signage needs."
    },
    {
        question: "What materials are used for plastic styrene sign printing?",
        answer: "Our plastic styrene signs printing services use high-quality, durable polystyrene material. This ensures fade-resistant, lightweight, and flexible signage suitable for indoor and outdoor applications."
    },
    {
        question: "Are styrene signs suitable for outdoor use?",
        answer: "Yes, styrene signs can be used outdoors for short-term applications. Our printing-on-styrene process ensures UV-resistant graphics that maintain their appearance under various conditions, making them ideal for temporary outdoor signage."
    },
    {
        question: "What industries benefit from styrene sign printing services?",
        answer: "Retail, hospitality, events, education, and corporate sectors benefit from styrene sign printing. Styrene signs are used for promotional displays, directional signage, and informational boards."
    },
    {
        question: "How long does it take to complete a bulk styrene sign order?",
        answer: "Bulk orders for printing of Styrene Signs are typically completed within a few business days, depending on the volume and design complexity. We prioritise efficiency and ensure on-time delivery."
    },
    {
        question: "Can I customise the design for my styrene signs?",
        answer: "Our custom styrene sign printing services allow full customisation, including size, colour, graphics, and finishing options. You can add logos, text, and unique designs to align with your branding goals."
    },
    {
        question: "What makes styrene signs ideal for retail promotions?",
        answer: "Styrene signs are lightweight, easy to transport and provide vibrant visuals, perfect for retail promotions, seasonal campaigns, and in-store advertising. Their affordability also makes them suitable for bulk printing."
    },
    {
        question: "How do I place an order for styrene sign printing?",
        answer: "To place an order, visit our website, select your specifications for styrene sign printing, upload your artwork, and confirm your order. Our team ensures seamless production and delivery."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing of Styrene Signs');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title="Custom Styrene Signs Printing Services for Branding"
  description="Professional printing of styrene signs for indoor and outdoor displays. Bulk sign printing, custom styrene sign printing, and plastic styrene sign printing solutions."
  keywords="Printing of Styrene Signs,
Styrene Sign Printing,
Custom Styrene Sign Printing,
Printing On Styrene,
Plastic Styrene Signs Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Styrene Signs</h1>
              <h2 className="text-muted">
              Custom styrene signs for impactful indoor and outdoor branding
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Styrene signs are lightweight, versatile, and durable solutions for retail, events, and promotional displays. Printingy specialises in printing Styrene Signs, offering high-quality styrene sign printing for businesses and events.</p>
          <p>Our Custom Styrene Sign Printing services cater to unique branding needs, providing sharp visuals and vibrant colours on durable plastic material. We also offer printing on styrene for promotional campaigns, exhibitions, and directional signage tailored to meet your requirements.</p>
          <p>With plastic styrene signs printing solutions, Printingy ensures cost-effective and reliable signage that withstands frequent use and delivers a professional appearance for all your marketing efforts.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row>
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Styrene Sign Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and lightweight signs for versatile use</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of Styrene Signs for indoor and outdoor applications.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk styrene sign printing at competitive rates for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional custom styrene sign printing with vibrant, fade-resistant graphics.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable plastic styrene sign printing for long-lasting signage.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for precise printing on styrene with sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight, flexible materials are ideal for easy installation and transport.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and custom orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for retailers, event organisers, and corporate branding.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/styereneprints.jpg" // Path relative to the public folder
                  alt="Durable plastic styrene sign printing for displays"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Styrene Signs Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your styrene sign printing needs</h3>
            <p>At Printingy, we combine advanced techniques and high-quality styrene material to deliver exceptional styrene sign printing services. Our custom styrene sign printing ensures professional and durable results, whether for point-of-sale displays, directional signs, or event branding.</p>
            <p>Our streamlined production process guarantees timely delivery for bulk orders without compromising quality. Partner with Printingy for reliable signage that enhances your branding and marketing campaigns.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default StyreneSigns;
